var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from "vue";
import { Card, Icon, Badge, Modal, Button } from "ant-design-vue-findsoft";
import dayjs from "dayjs";
Vue.use(Modal);
var MyIcon = Icon.createFromIconfontCN({
    scriptUrl: "/policy/static/fanalysis_icon_1845603/iconfont.js" // 在 iconfont.cn 上生成
});
Vue.use(Modal);
export default Vue.extend({
    components: {
        aCard: Card,
        MyIcon: MyIcon,
        aBadge: Badge,
        aButton: Button
    },
    computed: {
        userInfor: function () {
            return this.$store.state.userInfor;
        },
        role: function () {
            return JSON.parse(sessionStorage.getItem("token") || "{}");
        },
        list: function () {
            return this.$store.getters.getNoteList;
        }
    },
    data: function () {
        return {
            offset: [-2, 6],
            style: {
                width: "10px",
                height: "10px",
                background: "#FF6600"
            },
            classData: {},
            exlist: [],
            noteList: [],
            page: 1,
            systemTime: 0,
            visible: false,
            doneLength: 0
        };
    },
    mounted: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$store.dispatch("queryUserInfo", JSON.parse(sessionStorage.getItem("token")).code)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$store.dispatch("updataNotlist")];
                    case 2:
                        _a.sent();
                        this.listWithoutNotification();
                        this.querystudentclass();
                        this.querytrainProgress(1);
                        this.getCurrentTimeMillis();
                        this.query();
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: {
        gotoNotice: function () {
            this.$router.push("/Student/notice");
        },
        query: function () {
            var _this = this;
            // 流程演练 查看详情
            this.$axios.getEndExperimentCount().then(function (res) {
                _this.doneLength = res.data.data;
            });
        },
        state: function (v) {
            if (new Date(v.startTime).getTime() - this.systemTime > 0) {
                return "未开始";
            }
            else {
                return "开始实训";
            }
        },
        getCurrentTimeMillis: function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.$axios
                    .getCurrentTimeMillis()
                    .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        this.systemTime = res.data.data;
                        resolve();
                        return [2 /*return*/];
                    });
                }); })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
        nextPage: function (num) {
            if (this.page + num < 1) {
                return false;
            }
            else {
                // this.page += num
                var pagenum = this.page + num;
                this.querytrainProgress(pagenum);
            }
        },
        gotoList: function () {
            // 去查看报告页面
            this.$router.push("/Student/reportList");
        },
        gonovice: function (v) {
            if (new Date(v.endTime).getTime() - new Date().getTime() < v.totalTime * 60000 &&
                !v.firstEntry) {
                return (this.visible = true);
                // return this.$warning({
                //   title: "提示",
                //   content: "剩余时间不足，无法进入！"
                // });
            }
            // this.$store.commit("changeExpState", false);
            sessionStorage.setItem("firstEntry", v.firstEntry);
            sessionStorage.setItem("isExpOver", "false");
            sessionStorage.setItem("caseData", JSON.stringify(v));
            sessionStorage.removeItem("endstate");
            // 开始实训
            this.$router.push({
                name: "doCase",
                params: {
                    id: v.intelligentExperimentId,
                    intelligentExpId: v.intelligentExpId
                }
            });
        },
        querystudentclass: function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.$axios
                    .querystudentclass({ userCode: _this.role.code })
                    .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        this.classData = res.data.data;
                        resolve();
                        return [2 /*return*/];
                    });
                }); })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
        querytrainProgress: function (pagenum) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.$axios
                    .queryPolicyAnalysis()
                    .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        if (res.data.data.length > 0) {
                            this.$nextTick(function () {
                                var _a;
                                res.data.data.map(function (params) {
                                    params.endTime = dayjs(params.endTime).format("YYYY-MM-DD HH:mm:ss");
                                });
                                // @ts-ignore
                                (_a = _this.exlist).splice.apply(_a, __spreadArrays([0, _this.exlist.length], res.data.data));
                                console.log("🚀 ~ .then ~ this.exlist:", _this.exlist);
                            });
                            this.page = pagenum;
                        }
                        resolve();
                        return [2 /*return*/];
                    });
                }); })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
        handlingTime: function (list) {
            var Checkminute = 1000 * 60;
            var Checkhour = Checkminute * 60;
            var Checkday = Checkhour * 24;
            var Checkmonth = Checkday * 30;
            var nowTime = new Date().getTime();
            list.forEach(function (res1) {
                // 转换时间戳算时间差
                var createdTime = new Date(res1.createdTime).getTime();
                var lastTime = nowTime - createdTime;
                if (lastTime / Checkmonth >= 1) {
                    res1.time = parseInt((lastTime / Checkmonth)) + "\u6708\u524D";
                }
                else if (lastTime / (7 * Checkday) >= 1) {
                    res1.time = parseInt((lastTime / (7 * Checkday))) + "\u5468\u524D";
                }
                else if (lastTime / Checkday >= 1) {
                    res1.time = parseInt((lastTime / Checkday)) + "\u5929\u524D";
                }
                else if (lastTime / Checkhour >= 1) {
                    res1.time = parseInt((lastTime / Checkhour)) + "\u5C0F\u65F6\u524D";
                }
                else if (lastTime / Checkminute >= 1) {
                    res1.time = parseInt((lastTime / Checkminute)) + "\u5206\u949F\u524D";
                }
                else {
                    res1.time = "刚刚";
                }
            });
        },
        listWithoutNotification: function () {
            if (this.userInfor.student) {
                // this.$store.dispatch("updataNotlist");
                this.noteList = this.list.filter(function (ele) {
                    return ele.isRead === 0;
                });
                this.handlingTime(this.noteList);
            }
            else {
                this.noteList = [];
            }
        }
    }
});
